import React from 'react'
import { Dimmer } from 'semantic-ui-react'
import LoadingInline from './loadingInline'

const Loading = (props) => {
    const active = props && props.isActive ? props.isActive : false

    return <Dimmer style={{ position: 'fixed' }} active={active}>
        <LoadingInline />
    </Dimmer>
}

export default Loading


// WEBPACK FOOTER //
// ./src/app/components/features/share/loading.js